import { render, staticRenderFns } from "./MaterialView.vue?vue&type=template&id=67fd9499&scoped=true&"
import script from "./MaterialView.vue?vue&type=script&lang=js&"
export * from "./MaterialView.vue?vue&type=script&lang=js&"
import style0 from "./MaterialView.vue?vue&type=style&index=0&id=67fd9499&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fd9499",
  null
  
)

export default component.exports